import { Heading } from '@/components/base/heading'
import { Table } from '@/components/devices/table'

export const Index = () => {
  return (<div className="flex flex-col gap-3">
    <Heading level={ 1 } size="3xl">Devices</Heading>
    <Table />
  </div>)
}
